module.exports = __webpack_public_path__ + "static/img/meikuang.97516344.png";